import type { SpotifyState } from './types';

const initialState: SpotifyState = {
  popularSongs: {
    songs: null,
    error: false,
  },
  profile: {},
  searchedSongs: {
    songs: null,
    error: false,
  },
  // TODO add top artists
};

export default initialState;
